import { useCustomerInvitationsQuery } from './useCustomerInvitationsQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface InviteCustomerMutationParams {
  accountId: string;
  email?: string;
}

export const useInviteCustomerMutation = createMutationHook(
  'settings.customerPortal.inviteCustomer',
  (params: InviteCustomerMutationParams) => ({
    crmCustomerInvite: {
      __args: {
        input: {
          accountId: params.accountId,
          email: params.email,
        },
      },
      id: true,
      accountId: true,
      email: true,
      invitationStatus: true,
      sentAt: true,
      expiresAt: true,
      account: {
        id: true,
        name: true,
      },
    },
  }),
  {
    invalidateQueries: [useCustomerInvitationsQuery],
  },
);
